<template>
  <div id="ChartCriteria" class="row no-gutters">
    <div class="col">
      <form accept-charset="UTF-8" enctype="multipart/form-data" autocomplete="off" class="form" action="#" method="post" novalidate="novalidate" :id="chartFormId">
        <div class="mt-3">
          <div v-if="!display" class="container pt-2">
            <chart-criteria-skeleton />
          </div>
          <div v-if="display" class="container pt-2">
            <div v-if="!stylesMode" class="roadmap-v2-options">
              <div class="show-hide-links">
                <div class="chart-criteria-section-1" style="border-right: none;">
                  <div class="chart-segment-options">
                    <modal-link modal-id="Period/Group Options" :content-list="pageContent"></modal-link>
                    <a href="#" v-show="!displayChartCriteriaPeriod" @click.prevent="toggleChartCriteriaPeriod">Show Period/Profile Options<i class="fa fa-chevron-down ml-1"></i></a>
                    <a href="#" v-show="displayChartCriteriaPeriod" @click.prevent="toggleChartCriteriaPeriod">Hide Period/Profile Options<i class="fa fa-chevron-up ml-1"></i></a>
                  </div>
                </div>
                <div class="chart-criteria-section-2" style="border-right: none;">
                  <div class="chart-segment-options">
                    <modal-link modal-id="Analytics Options" :content-list="pageContent"></modal-link>
                    <a href="#" v-show="!displayChartCriteriaAnalytics" @click.prevent="toggleChartCriteriaAnalytics">Show Initiative Options<i class="fa fa-chevron-down ml-1"></i></a>
                    <a href="#" v-show="displayChartCriteriaAnalytics" @click.prevent="toggleChartCriteriaAnalytics">Hide Initiative Options<i class="fa fa-chevron-up ml-1"></i></a>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="chart-criteria-section-1 chart-criteria-border">
                  <div v-show="displayChartCriteriaPeriod" class="w-100">
                    <div class="chart-criteria-row">
                      <div class="chart-criteria-label-column"><label for="roadmapValueProfile" class="sub-heading-label">Value Profile</label></div>
                      <div class="chart-criteria-field-column">
                        <select id="roadmapValueProfile" name="roadmapValueProfile" class="custom-select required shadow w-100" :disabled="disableChartCriteriaWidgets" v-model="valueProfileClientChartId" @change="changeValueProfile">
                          <option value="">Select</option>
                          <option v-for="profile in valueProfileOptions" :key="profile.clientChartId" :value="String(profile.clientChartId)">{{ profile.name }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="chart-criteria-row">
                      <div class="chart-criteria-label-column"><label for="roadmapV2Period" class="sub-heading-label">Period</label></div>
                      <div class="chart-criteria-field-column">
                        <select id="roadmapV2Period" name="roadmapV2Period" class="custom-select required shadow w-100" :disabled="disableChartCriteriaWidgets" v-model="period" @change="saveTimePeriodEvent($event, 'Period', 'period', true)">
                          <option value="">Select</option>
                          <option v-for="(option, index) in period_options" :key="index" :value="option.value">{{ option.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chart-criteria-section-2 chart-criteria-border">
                  <div v-show="displayChartCriteriaAnalytics" class="w-100">
                    <div class="chart-criteria-row">
                      <div class="chart-criteria-label-column"><label for="roadmapSuggestionCount" class="sub-heading-label"># of Suggestions</label></div>
                      <div class="chart-criteria-field-column">
                        <select id="roadmapSuggestionCount" class="custom-select required shadow w-100" :disabled="disableChartCriteriaWidgets" v-model.number="numberOfSuggestions">
                          <option v-for="count in numberOfSuggestionOptions" :key="count" :value="count">{{ count }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="chart-criteria-row">
                      <div class="chart-criteria-label-column"><label for="roadmapAiType" class="sub-heading-label">AI Toolset</label></div>
                      <div class="chart-criteria-field-column">
                        <select id="roadmapAiType" class="custom-select shadow w-100" :disabled="disableChartCriteriaWidgets || disableAiToolset" v-model="roadmapAiTypeId">
                          <option value="0">{{ defaultAiTypeOptionText }}</option>
                          <option v-for="option in ai_type_options" :key="option.aiTypeId" :value="option.aiTypeId">{{ option.displayName }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="chart-criteria-row">
                      <div class="chart-criteria-label-column"><label for="roadmapFinancialMetric" class="sub-heading-label">Financial Metric</label></div>
                      <div class="chart-criteria-field-column">
                        <select id="roadmapFinancialMetric" class="custom-select required shadow w-100" :disabled="disableChartCriteriaWidgets" v-model="metric">
                          <option value="">Select</option>
                          <option v-for="(option, index) in metric_options" :key="index" :value="option.value">{{ option.name }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="chart-criteria-row">
                      <div class="chart-criteria-label-column"><label id="roadmapSimulationFocusLabel" class="sub-heading-label">Top 5 Simulations Focus</label></div>
                      <div class="chart-criteria-field-column d-flex align-items-center flex-wrap" role="radiogroup" aria-labelledby="roadmapSimulationFocusLabel">
                        <label v-for="option in roadmapSimulationFocusOptions" :key="option.value" class="mb-0 mr-2">
                          <input type="radio" class="mr-1" name="roadmapSimulationFocus" :value="option.value" v-model="roadmapSimulationFocus" :disabled="disableChartCriteriaWidgets" /> {{ option.label }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="stylesMode"
              :class="{
                'wizard-styles-options': currentView === 'wizard-styles',
                'wizard-battlecard-view': currentView === 'battlecard'
              }"
            >
              <div class="show-hide-links">
                <div class="chart-criteria-section-1" style="border-right: none;">
                  <div class="chart-segment-options">
                    <modal-link :modal-id="currentView === 'battlecard' ? 'Period/Group Options - Battlecards' : 'Period/Group Options'" :content-list="pageContent"></modal-link>
                    <a href="#" v-show="!displayChartCriteriaPeriod" @click.prevent="toggleChartCriteriaPeriod">Show Period/Profile Options<i class="fa fa-chevron-down ml-1"></i></a>
                    <a href="#" v-show="displayChartCriteriaPeriod" @click.prevent="toggleChartCriteriaPeriod">Hide Period/Profile Options<i class="fa fa-chevron-up ml-1"></i></a>
                  </div>
                </div>
                <div class="chart-criteria-section-2" style="border-right: none;">
                  <div class="chart-segment-options">
                    <modal-link modal-id="Analytics Options" :content-list="pageContent"></modal-link>
                    <a href="#" v-show="!displayChartCriteriaAnalytics" @click.prevent="toggleChartCriteriaAnalytics">Show {{ wizardMode && currentView === 'battlecard' ? 'Battlecard' : (currentView === 'scout' ? 'Scout' : 'Styles') }} Options<i class="fa fa-chevron-down ml-1"></i></a>
                    <a href="#" v-show="displayChartCriteriaAnalytics" @click.prevent="toggleChartCriteriaAnalytics">Hide {{ wizardMode && currentView === 'battlecard' ? 'Battlecard' : (currentView === 'scout' ? 'Scout' : 'Styles') }} Options<i class="fa fa-chevron-up ml-1"></i></a>
                  </div>
                </div>
                <div class="chart-criteria-section-3" style="border-right: none;">
                  <div class="chart-segment-options">
                    <modal-link :modal-id="currentView === 'battlecard' ? 'Individual Options - Battlecards' : 'Individual Options'" :content-list="pageContent"></modal-link>
                    <a href="#" v-show="!displayChartCriteriaSegments" @click.prevent="toggleChartCriteriaSegments">Show Individual Options<i class="fa fa-chevron-down ml-1"></i></a>
                    <a href="#" v-show="displayChartCriteriaSegments" @click.prevent="toggleChartCriteriaSegments">Hide Individual Options<i class="fa fa-chevron-up ml-1"></i></a>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="chart-criteria-section-1 chart-criteria-border">
                  <div v-show="displayChartCriteriaPeriod" class="w-100">
                    <div class="chart-criteria-row">
                      <div :class=" currentView === 'battlecard' ? 'chart-criteria-label-column pb-4' : 'chart-criteria-label-column'"><label for="roadmapValueProfile" class="sub-heading-label">Value Profile</label></div>
                      <div class="chart-criteria-field-column">
                        <select id="roadmapValueProfile" name="roadmapValueProfile" class="custom-select required shadow w-100" :disabled="disableChartCriteriaWidgets" v-model="valueProfileClientChartId" @change="changeValueProfile">
                          <option value="">Select</option>
                          <option v-for="profile in valueProfileOptions" :key="profile.clientChartId" :value="String(profile.clientChartId)">{{ profile.name }}</option>
                        </select>
                        <small v-if="wizardMode && currentView === 'battlecard'" class="wizard-value-profile-hint">Value Profiles populate the Individuals Options.</small>
                      </div>
                    </div>
                    <div class="chart-criteria-row">
                      <div class="chart-criteria-label-column"><label for="roadmapV2Period" class="sub-heading-label">Period</label></div>
                      <div class="chart-criteria-field-column">
                        <select id="roadmapV2Period" name="roadmapV2Period" class="custom-select required shadow w-100" :disabled="disableChartCriteriaWidgets" v-model="period" @change="saveTimePeriodEvent($event, 'Period', 'period', true)">
                          <option value="">Select</option>
                          <option v-for="(option, index) in period_options" :key="index" :value="option.value">{{ option.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chart-criteria-section-2 chart-criteria-border">
                  <div v-show="displayChartCriteriaAnalytics" class="w-100">
                    <div v-if="currentView === 'wizard-styles' && showCompetitors && hasCompetitors" class="chart-criteria-row">
                      <div class="chart-criteria-label-column"><label class="sub-heading-label">Competitors</label></div>
                      <div class="chart-criteria-field-column">
                        <multiselect
                          ref="competitorsSelect"
                          v-model="values"
                          :disabled="disableChartCriteriaWidgets"
                          :options="competitor_options"
                          :multiple="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          :max-height="250"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          placeholder="Select"
                          label="name"
                          :max="maximumCompetitors"
                          name="multi-competitor"
                          track-by="companyId"
                          :preselect-first="false"
                          @select="addCompany"
                          @remove="removeCompany"
                        >
                          <template slot="maxElements"><span style="color: #e54d42">{{ maximumCompetitorMessage }}</span></template>
                          <template #option="props">
                            <span class="checkbox-label" @click.self="select(props.option)">
                              <input name="multi-competitor" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                              {{ props.option.name }}
                            </span>
                          </template>
                        </multiselect>
                      </div>
                    </div>
                    <div v-if="currentView === 'scout'" class="wizard-scout-options">
                      <div class="chart-criteria-row">
                        <div class="chart-criteria-label-column"><label class="sub-heading-label">Scout Report Type</label></div>
                        <div class="chart-criteria-field-column">
                          <div v-for="option in scoutReportTypeOptions" :key="option.value" class="form-check d-flex align-items-center justify-content-start text-left pl-0">
                            <input :id="'scoutReportType-' + option.value" v-model="scout_report_type" class="form-check-input position-static mt-0 mr-2 ml-0" type="radio" name="scout_report_type" :value="option.value" :disabled="disableChartCriteriaWidgets" />
                            <label class="form-check-label mb-0 text-left" :for="'scoutReportType-' + option.value">{{ option.name }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="chart-criteria-row">
                        <div class="chart-criteria-label-column"><label class="sub-heading-label">Periods</label></div>
                        <div class="chart-criteria-field-column">
                          <multiselect
                            v-model="periods"
                            :disabled="disableChartCriteriaWidgets"
                            :options="period_options"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            :max-height="250"
                            select-label=""
                            deselect-label=""
                            selected-label=""
                            placeholder="Select"
                            label="name"
                            name="scout-periods"
                            track-by="value"
                            :preselect-first="false"
                            @select="onScoutPeriodSelect"
                            @remove="onScoutPeriodRemove"
                          >
                            <template #option="props">
                              <span class="checkbox-label" @click.self="select(props.option)">
                                <input name="scout-periods" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                                {{ props.option.name }}
                              </span>
                            </template>
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div v-if="wizardMode && currentView === 'battlecard'" class="wizard-battlecard-options">
                      <div class="chart-criteria-row">
                        <div class="chart-criteria-label-column"><label class="sub-heading-label">Analysis Includes</label></div>
                        <div class="chart-criteria-field-column wizard-battlecard-checkboxes">
                          <label><input v-model="includeValueGaps" type="checkbox" true-value="Y" false-value="N" @change="emitBattlecardCriteria" /> Value Gaps</label>
                          <label><input v-model="includeExpectations" type="checkbox" true-value="Y" false-value="N" @change="emitBattlecardCriteria" /> Expectations</label>
                          <label><input v-model="includePerformance" type="checkbox" true-value="Y" false-value="N" @change="emitBattlecardCriteria" /> Performance</label>
                          <label><input v-model="includeCompetitor" type="checkbox" true-value="Y" false-value="N" @change="emitBattlecardCriteria" /> Competitors</label>
                          <label><input v-model="includeWillingnessToPay" type="checkbox" true-value="Y" false-value="N" @change="emitBattlecardCriteria" /> Willingness</label>
                          <label><input v-model="includeVerbatims" type="checkbox" true-value="Y" false-value="N" @change="emitBattlecardCriteria" /> Verbatims</label>
                        </div>
                      </div>
                      <div class="chart-criteria-row">
                        <div class="chart-criteria-label-column"><label for="battlecardNumberOfIdeas" class="sub-heading-label"># of Ideas</label></div>
                        <div class="chart-criteria-field-column">
                          <select id="battlecardNumberOfIdeas" class="custom-select shadow w-100" v-model.number="numberOfIdeas" @change="emitBattlecardCriteria">
                            <option :value="0">Select</option>
                            <option v-for="count in numberOfIdeaOptions" :key="count" :value="count">{{ count }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="chart-criteria-row">
                        <div class="chart-criteria-label-column"><label for="battlecardAiType" class="sub-heading-label">AI Toolset</label></div>
                        <div class="chart-criteria-field-column">
                          <select id="battlecardAiType" class="custom-select shadow w-100" :disabled="disableChartCriteriaWidgets || disableAiToolset" v-model="roadmapAiTypeId" @change="emitBattlecardCriteria">
                            <option value="0">{{ defaultAiTypeOptionText }}</option>
                            <option v-for="option in ai_type_options" :key="option.aiTypeId" :value="option.aiTypeId">{{ option.displayName }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chart-criteria-section-3 chart-criteria-border">
                  <div v-show="displayChartCriteriaSegments" class="w-100">
                    <div v-if="wizardMode && (currentView === 'battlecard' || currentView === 'wizard-styles' || currentView === 'scout')" class="wizard-individual-options">
                      <div class="wizard-individual-list-header">
                        <span>Select up to 30 Individuals at a time <span class="wizard-individual-list-count">({{ selectedBattlecardRespondents.length }} / 30 selected)</span></span>
                        <input v-model="individualRespondentSearch" type="search" class="form-control form-control-sm" aria-label="Search individuals" placeholder="Search" />
                      </div>
                      <div class="wizard-individual-list-table-container">
                        <table class="table table-sm table-hover individual-respondents-table">
                          <thead>
                            <tr>
                              <th class="select-column"><input type="checkbox" :checked="areAllDisplayedBattlecardRespondentsSelected" @change="toggleDisplayedBattlecardRespondents" /></th>
                              <th :aria-sort="individualRespondentSortKey === 'dateCompleted' ? (individualRespondentSortDirection === 'asc' ? 'ascending' : 'descending') : 'none'">
                                <button type="button" class="sort-header-button" @click="sortIndividualRespondents('dateCompleted')">
                                  Date<span class="sort-indicator" aria-hidden="true"><i v-if="individualRespondentSortKey === 'dateCompleted'" class="fa" :class="individualRespondentSortDirection === 'asc' ? 'fa-angle-up' : 'fa-angle-down'"></i></span>
                                </button>
                              </th>
                              <th :aria-sort="individualRespondentSortKey === 'company' ? (individualRespondentSortDirection === 'asc' ? 'ascending' : 'descending') : 'none'">
                                <button type="button" class="sort-header-button" @click="sortIndividualRespondents('company')">
                                  Company<span class="sort-indicator" aria-hidden="true"><i v-if="individualRespondentSortKey === 'company'" class="fa" :class="individualRespondentSortDirection === 'asc' ? 'fa-angle-up' : 'fa-angle-down'"></i></span>
                                </button>
                              </th>
                              <th :aria-sort="individualRespondentSortKey === 'name' ? (individualRespondentSortDirection === 'asc' ? 'ascending' : 'descending') : 'none'">
                                <button type="button" class="sort-header-button" @click="sortIndividualRespondents('name')">
                                  Name<span class="sort-indicator" aria-hidden="true"><i v-if="individualRespondentSortKey === 'name'" class="fa" :class="individualRespondentSortDirection === 'asc' ? 'fa-angle-up' : 'fa-angle-down'"></i></span>
                                </button>
                              </th>
                              <th :aria-sort="individualRespondentSortKey === 'emailAddress' ? (individualRespondentSortDirection === 'asc' ? 'ascending' : 'descending') : 'none'">
                                <button type="button" class="sort-header-button" @click="sortIndividualRespondents('emailAddress')">
                                  Email<span class="sort-indicator" aria-hidden="true"><i v-if="individualRespondentSortKey === 'emailAddress'" class="fa" :class="individualRespondentSortDirection === 'asc' ? 'fa-angle-up' : 'fa-angle-down'"></i></span>
                                </button>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="respondent in filteredIndividualRespondents" :key="respondent.surveyTakerId">
                              <td class="select-column"><input type="checkbox" :checked="isBattlecardRespondentSelected(respondent)" @change="toggleBattlecardRespondent(respondent, $event)" /></td>
                              <td>{{ formatRespondentDate(respondent.dateCompleted) }}</td>
                              <td>{{ respondent.company }}</td>
                              <td>{{ respondent.name }}</td>
                              <td>{{ respondent.emailAddress }}</td>
                            </tr>
                            <tr v-if="filteredIndividualRespondents.length === 0">
                              <td colspan="5" class="empty-message">No individual respondents to display.</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-if="battlecardSelectionMessage" class="text-danger" role="status">{{ battlecardSelectionMessage }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!stylesMode" class="form-row">
              <div v-if="viewNavigationOptions.length > 0" class="form-group roadmap-view-navigation">
                <label class="control-label pt-1 pr-1 my-auto">{{ viewNavigationLabel }}</label>
                <div class="d-flex justify-content-left flex-wrap">
                  <chart-type-card
                    v-for="(option, index) in viewNavigationOptions"
                    :key="index"
                    :chart-type="option.value"
                    :display-name="option.name"
                    :current-display-type="currentView"
                    :disabled="option.disabled === true"
                    @select="$emit('select-view', $event)"
                  />
                </div>
              </div>
              <div v-if="currentView === 'battlecard'" class="d-flex align-items-center pl-2" style="padding-top:30px">
                <div class="d-flex btn-group-horizontal align-items-start position-relative sales-wizard-actions wizard-battlecard-actions" role="group">
                  <button type="button" class="btn btn-primary mr-2 wizard-action-button" :disabled="disableChartCriteriaWidgets || disableAiToolset || Number(roadmapAiTypeId) === 0 || selectedBattlecardRespondents.length === 0 || battlecardProcessing || !battlecardCanBuild" @click="$emit('build-battlecards')">
                    Build Battlecards
                  </button>
                  <button type="button" class="btn btn-primary mr-2 wizard-action-button" :disabled="disableChartCriteriaWidgets || disableAiToolset || Number(roadmapAiTypeId) === 0 || selectedBattlecardRespondents.length === 0 || battlecardProcessing || !battlecardCanBuild" @click="$emit('send-battlecards')">
                    Send Battlecards
                  </button>
                  <div class="sales-wizard-email-field wizard-battlecard-email-field">
                    <input v-model="briefEmailRecipients" type="text" class="form-control" placeholder="Enter email(s) to send Battlecards" aria-label="Email addresses to send Battlecards" @input="emitBattlecardCriteria" />
                    <small>To send Battlecards to multiple recipients, type each email address separated by a comma</small>
                  </div>
                  <button id="save_chart" class="btn btn-primary ml-2 wizard-action-button" type="button" @click="openSaveChartModal" :disabled="disableChartCriteriaWidgets || $parent.disableSaveAsCardButton">Save as Card</button>
                </div>
              </div>
              <div v-else class="d-flex align-items-center pl-2"  style="padding-top:30px">
                <div class="d-flex btn-group-horizontal align-items-center position-relative" role="group">
                  <button type="button" class="btn btn-primary mr-2" @click="runChart" :disabled="roadmapAnalyzeDisabled" :aria-describedby="roadmapHasNoValueProfiles ? 'roadmap-value-profile-error' : null">
                    <span>{{ generateLabel }}</span>
                    <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
                  </button>
                  <button id="roadmapSimulate" type="button" class="btn btn-primary mr-2" @click="runRoadmapSimulation" :disabled="!roadmapSimulationEnabled || disableChartCriteriaWidgets || roadmapAnalyzeDisabled">Simulate</button>
                  <button type="button" class="btn btn-primary" @click="resetRoadmapV2Criteria">Reset</button>
                  <div v-show="!$parent.generatingChart && $parent.displayView" class="show-hide-chart-criteria-results ml-2">
                    <button id="save_chart" class="btn btn-primary mr-2 wizard-action-button" type="button" @click="openSaveChartModal" :disabled="disableChartCriteriaWidgets || $parent.disableSaveAsCardButton">Save as Card</button>
                    <a href="#" v-show="!$parent.displayChartCriteriaResults" @click.prevent="toggleChartCriteriaResults">Show Chart Criteria Selections<i class="fa fa-chevron-down ml-1"></i></a>
                    <a href="#" v-show="$parent.displayChartCriteriaResults" @click.prevent="toggleChartCriteriaResults">Hide Chart Criteria Selections<i class="fa fa-chevron-up ml-1"></i></a>
                  </div>
                  <p v-if="roadmapHasNoValueProfiles" id="roadmap-value-profile-error" class="text-danger mt-2 mb-0 position-absolute text-nowrap" style="top: 100%; left: 0;" role="alert">Roadmaps require at least 1 saved Value Profile.</p>
                </div>
              </div>
            </div>
            <div v-else class="form-row">
              <div class="form-group roadmap-view-navigation">
                <label class="control-label pt-1 pr-1 my-auto">Views</label>
                <div class="d-flex justify-content-left flex-wrap">
                  <chart-type-card
                    v-for="(option, index) in viewNavigationOptions"
                    :key="index"
                    :chart-type="option.value"
                    :display-name="option.name"
                    :current-display-type="currentView"
                    :disabled="option.disabled === true"
                    @select="$emit('select-view', $event)"
                  />
                </div>
              </div>
              <div v-if="currentView === 'battlecard'" class="d-flex align-items-center pl-2" style="padding-top:30px">
                <div class="d-flex btn-group-horizontal align-items-start position-relative sales-wizard-actions wizard-battlecard-actions" role="group">
                  <button type="button" class="btn btn-primary mr-2 wizard-action-button" :disabled="disableChartCriteriaWidgets || disableAiToolset || Number(roadmapAiTypeId) === 0 || selectedBattlecardRespondents.length === 0 || battlecardProcessing || !battlecardCanBuild" @click="$emit('build-battlecards')">
                    Build Battlecards
                  </button>
                  <button type="button" class="btn btn-primary mr-2 wizard-action-button" :disabled="disableChartCriteriaWidgets || disableAiToolset || Number(roadmapAiTypeId) === 0 || selectedBattlecardRespondents.length === 0 || battlecardProcessing || !battlecardCanBuild" @click="$emit('send-battlecards')">
                    Send Battlecards
                  </button>
                  <div class="sales-wizard-email-field wizard-battlecard-email-field">
                    <input v-model="briefEmailRecipients" type="text" class="form-control" placeholder="Enter email(s) to send Battlecards" aria-label="Email addresses to send Battlecards" @input="emitBattlecardCriteria" />
                    <small>To send Battlecards to multiple recipients, type each email address separated by a comma</small>
                  </div>
                  <button id="save_chart" class="btn btn-primary ml-2 wizard-action-button" type="button" @click="openSaveChartModal" :disabled="disableChartCriteriaWidgets || $parent.disableSaveAsCardButton">Save as Card</button>
                </div>
              </div>
              <div v-else class="d-flex align-items-center pl-2 pt-3">
                <div class="d-flex btn-group-horizontal align-items-center position-relative" role="group">
                  <button type="button" class="btn btn-primary mr-2" @click="runChart" :disabled="(currentView !== 'wizard-styles' && currentView !== 'scout') || disableChartCriteriaWidgets || roadmapAnalyzeDisabled">
                    <span>{{ generateLabel }}</span>
                    <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
                  </button>
                  <button type="button" class="btn btn-primary mr-2" @click="resetStylesCriteria">Reset</button>
                  <button id="save_chart" class="btn btn-primary mr-2 wizard-action-button" type="button" @click="openSaveChartModal" :disabled="disableChartCriteriaWidgets || $parent.disableSaveAsCardButton">Save as Card</button>
                  <div v-show="!$parent.generatingChart && $parent.displayView" class="show-hide-chart-criteria-results ml-2">
                    <a href="#" v-show="!$parent.displayChartCriteriaResults" @click.prevent="toggleChartCriteriaResults">Show Chart Criteria Selections<i class="fa fa-chevron-down ml-1"></i></a>
                    <a href="#" v-show="$parent.displayChartCriteriaResults" @click.prevent="toggleChartCriteriaResults">Hide Chart Criteria Selections<i class="fa fa-chevron-up ml-1"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <chart-company v-show="false" ref="chartCompany" :client-id="clientId" :input-page-content="pageContent"></chart-company>
      </form>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ChartCriteria from "./ChartCriteria.vue";
import ChartCriteriaMixins from "../../mixins/ChartCriteriaMixins.vue";
import ContentMixins from "../../mixins/ContentMixins.vue";
import ClientChartService from "../../services/client.chart.service";
import AIService from "../../services/ai.service";
import SurveyService from "../../services/survey.service";
import UserService from "../../services/user.service";
import ChartService from "../../services/chart.service";
import ErrorService from "../../services/error.service";

export default {
  name: "ChartCriteriaRoadmap",
  extends: ChartCriteria,
  mixins: [ContentMixins, ChartCriteriaMixins],
  props: {
    stylesMode: { type: Boolean, default: false },
    wizardMode: { type: Boolean, default: false },
    battlecardCriteria: { type: Object, default: () => ({}) },
    battlecardProcessing: { type: Boolean, default: false },
    battlecardCanBuild: { type: Boolean, default: true },
    roadmapSimulationEnabled: { type: Boolean, default: false }
  },
  data() {
    return {
      displayChartCriteriaSegments: true,
      scout_report_type: "multiple-individuals-separately",
      scoutReportTypeOptions: [
        { name: "Multiple Individuals (Separately)", value: "multiple-individuals-separately" },
        { name: "Multiple Individuals (Together)", value: "multiple-individuals-together" },
        { name: "One Individual Over Time", value: "one-individual-over-time" }
      ],
      periods: [],
      valueProfileClientChartId: "",
      individualRespondents: [],
      individualRespondentRequestId: 0,
      selectedBattlecardRespondents: [],
      savedSelectedRespondentIds: [],
      individualRespondentSearch: "",
      individualRespondentSortKey: "company",
      individualRespondentSortDirection: "asc",
      battlecardSelectionMessage: "",
      includeValueGaps: "Y",
      includeExpectations: "Y",
      includePerformance: "Y",
      includeCompetitor: "Y",
      includeWillingnessToPay: "Y",
      includeVerbatims: "Y",
      numberOfIdeaOptions: [1, 2, 3, 4, 5, 10],
      numberOfIdeas: 0,
      briefEmailRecipients: "",
      numberOfSuggestions: 5,
      numberOfSuggestionOptions: [1, 2, 3, 4, 5, 10, 15],
      roadmapAiTypeId: 0,
      ai_type_options: [],
      roadmapSimulationOnly: false,
      roadmapSimulationFocus: "growth",
      roadmapSimulationFocusOptions: [
        { value: "growth", label: "Growth" },
        { value: "balanced", label: "Balanced" },
        { value: "performance", label: "Performance" }
      ],
      roadmapCriteriaResults: [],
      disableAiToolset: false,
      defaultAiTypeOptionText: ""
    };
  },
  computed: {
    roadmapCriteriaSignature() {
      return JSON.stringify([this.period, this.valueProfileClientChartId, this.numberOfSuggestions,
        this.roadmapAiTypeId, this.metric, this.roadmapSimulationFocus]);
    },
    valueProfileOptions() {
      const clientCharts = this.$parent.clientObject && this.$parent.clientObject.clientCharts;
      const surveyId = this.$parent.survey && this.$parent.survey.surveyId;
      return ClientChartService.getValueProfileCards(
        Array.isArray(clientCharts) ? clientCharts : this.saved_card_options,
        surveyId
      );
    },
    roadmapHasNoValueProfiles() {
      return this.valueProfileOptions.length === 0;
    },
    roadmapAnalyzeDisabled() {
      return !this.valueProfileClientChartId || !this.valueProfileOptions.some(
        profile => String(profile.clientChartId) === String(this.valueProfileClientChartId)
      );
    },
    filteredIndividualRespondents() {
      const search = this.individualRespondentSearch.trim().toLowerCase();
      const respondents = !search ? this.individualRespondents : this.individualRespondents.filter(respondent => [

        this.formatRespondentDate(respondent.dateCompleted),
        respondent.company,
        respondent.name,
        respondent.emailAddress
      ].some(value => String(value || "").toLowerCase().includes(search)));
      const key = this.individualRespondentSortKey;
      if (!key) return respondents;
      const direction = this.individualRespondentSortDirection === "asc" ? 1 : -1;
      return respondents.slice().sort((left, right) => {
        if (key === "dateCompleted") {
          const leftDate = left[key] ? new Date(left[key]).getTime() : NaN;
          const rightDate = right[key] ? new Date(right[key]).getTime() : NaN;
          if (Number.isNaN(leftDate)) return Number.isNaN(rightDate) ? 0 : 1;
          if (Number.isNaN(rightDate)) return -1;
          return (leftDate - rightDate) * direction;
        }
        return String(left[key] || "").localeCompare(String(right[key] || ""), undefined, {
          sensitivity: "base", numeric: true
        }) * direction;
      });
    },
    areAllDisplayedBattlecardRespondentsSelected() {
      return this.filteredIndividualRespondents.length > 0 && this.filteredIndividualRespondents.every(
        respondent => this.isBattlecardRespondentSelected(respondent)
      );
    },
    hasSelectedBattlecardAnalysis() {
      return [this.includeValueGaps, this.includeExpectations, this.includePerformance,
        this.includeCompetitor, this.includeWillingnessToPay, this.includeVerbatims].includes("Y");
    }
  },
  methods: {
    getRoadmapCriteriaResults() {
      const profile = this.valueProfileOptions.find(option => String(option.clientChartId) === String(this.valueProfileClientChartId));
      const aiType = this.ai_type_options.find(option => String(option.aiTypeId) === String(this.roadmapAiTypeId));
      const metric = this.metric_options.find(option => String(option.value) === String(this.metric));
      return [
        { name: "Value Profile", parameterName: "value_profile_client_chart_id", displayValue: profile ? profile.name : "Not selected" },
        { name: "# of Suggestions", parameterName: "number_of_suggestions", displayValue: String(this.numberOfSuggestions) },
        { name: "AI Toolset", parameterName: "roadmap_ai_type_id", displayValue: aiType ? aiType.displayName : "Not selected" },
        { name: "Financial Metric", parameterName: "metric", displayValue: this.metric && metric ? metric.name : "Not selected" },
        { name: "Top 5 Simulations Focus", parameterName: "roadmap_simulation_focus", displayValue: this.roadmapSimulationFocusOptions.find(option => option.value === this.roadmapSimulationFocus)?.label || "Growth" }
      ];
    },
    loadRoadmapAiTypes() {
      AIService.getAllActiveAITypes(this.setRoadmapAiTypeOptions);
    },
    setRoadmapAiTypeOptions(response) {
      this.ai_type_options = response;
      const configuredAiTypeId = this.$parent.clientSettings && this.$parent.clientSettings.aiTypeId;
      if (configuredAiTypeId == null || Number(configuredAiTypeId) == 0) {
        this.disableAiToolset = true;
        this.defaultAiTypeOptionText = "No AI Selected";
        this.roadmapAiTypeId = 0;
        if (this.wizardMode) this.emitBattlecardCriteria();
        return;
      }
      this.disableAiToolset = false;
      this.defaultAiTypeOptionText = "";
      if (!this.roadmapAiTypeId && configuredAiTypeId != null) {
        this.roadmapAiTypeId = configuredAiTypeId;
      }
      if (this.wizardMode) this.emitBattlecardCriteria();
    },
    changeValueProfile() {
      if (this.stylesMode) {
        const selectedProfileId = this.valueProfileClientChartId;
        this.resetStylesCriteria();
        this.valueProfileClientChartId = selectedProfileId;
      }
      return this.selectRoadmapValueProfile();
    },
    async selectRoadmapValueProfile() {
      const selectedProfile = this.valueProfileOptions.find(profile => String(profile.clientChartId) == String(this.valueProfileClientChartId));
      const hasSavedSelectedRespondentIds = this.savedSelectedRespondentIds.length > 0;
      this.$emit("select-value-profile", selectedProfile || null);
      const requestId = ++this.individualRespondentRequestId;
      this.individualRespondents = [];
      this.selectedBattlecardRespondents = [];
      this.battlecardSelectionMessage = "";
      if (!hasSavedSelectedRespondentIds) {
        this.savedSelectedRespondentIds = [];
      }
      this.emitBattlecardSelection();
      if (!this.stylesMode || !selectedProfile) {
        this.$emit("individual-respondents", this.individualRespondents);
        return this.individualRespondents;
      }

      let individualRespondents = [];
      try {
        individualRespondents = await ChartService.getSalesWizardIndividualRespondents(
          SurveyService.getSurveyId(),
          selectedProfile.clientChartId
        );
      } catch (error) {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("ChartCriteriaRoadmap.selectRoadmapValueProfile", error, "chart", this);
      }
      if (requestId !== this.individualRespondentRequestId) return this.individualRespondents;

      this.individualRespondents = individualRespondents;
      if (this.savedSelectedRespondentIds.length > 0) {
        this.$nextTick(() => {
          if (requestId === this.individualRespondentRequestId) {
            this.applySavedSelectedRespondentIds();
          }
        });
      }
      this.$emit("individual-respondents", this.individualRespondents);
      return this.individualRespondents;
    },
    getBattlecardCriteria() {
      return {
        includeValueGaps: this.includeValueGaps,
        includeExpectations: this.includeExpectations,
        includePerformance: this.includePerformance,
        includeCompetitor: this.includeCompetitor,
        includeWillingnessToPay: this.includeWillingnessToPay,
        includeVerbatims: this.includeVerbatims,
        numberOfRecommendations: this.numberOfIdeas,
        salesWizardAiTypeId: this.roadmapAiTypeId,
        briefEmailRecipients: this.briefEmailRecipients
      };
    },
    emitBattlecardCriteria() {
      this.$emit("battlecard-criteria-changed", this.getBattlecardCriteria());
    },
    emitBattlecardSelection() {
      this.$emit("battlecard-selection-changed", this.selectedBattlecardRespondents.slice());
    },
    setSavedSelectedRespondentIds(ids = []) {
      this.savedSelectedRespondentIds = Array.isArray(ids) ? ids.map(String) : [];
      if (this.individualRespondents.length > 0) {
        this.$nextTick(() => this.applySavedSelectedRespondentIds());
      }
    },
    applySavedSelectedRespondentIds() {
      if (this.savedSelectedRespondentIds.length === 0) {
        this.selectedBattlecardRespondents = [];
        this.emitBattlecardSelection();
        return;
      }

      if (!Array.isArray(this.individualRespondents) || this.individualRespondents.length === 0) {
        return;
      }

      const selectedIds = this.savedSelectedRespondentIds.map(String);
      this.selectedBattlecardRespondents = this.individualRespondents.filter(respondent =>
        selectedIds.includes(String(respondent.surveyTakerId))
      );
      this.emitBattlecardSelection();
    },
    isBattlecardRespondentSelected(respondent) {
      return this.selectedBattlecardRespondents.some(selected => selected.surveyTakerId == respondent.surveyTakerId);
    },
    toggleBattlecardRespondent(respondent, event) {
      const selected = this.selectedBattlecardRespondents.slice();
      if (event.target.checked) {
        if (selected.length >= 30) {
          event.target.checked = false;
          this.battlecardSelectionMessage = "Only 30 individuals can be selected.";
          return;
        }
        if (!this.isBattlecardRespondentSelected(respondent)) selected.push(respondent);
      } else {
        const selectedIndex = selected.findIndex(item => item.surveyTakerId == respondent.surveyTakerId);
        if (selectedIndex >= 0) selected.splice(selectedIndex, 1);
      }
      this.selectedBattlecardRespondents = selected;
      this.battlecardSelectionMessage = "";
      this.emitBattlecardSelection();
    },
    toggleDisplayedBattlecardRespondents(event) {
      const selected = this.selectedBattlecardRespondents.slice();
      const displayed = this.filteredIndividualRespondents;
      if (event.target.checked) {
        displayed.forEach(respondent => {
          if (selected.length < 30 && !selected.some(item => item.surveyTakerId == respondent.surveyTakerId)) {
            selected.push(respondent);
          }
        });
        if (displayed.some(respondent => !selected.some(item => item.surveyTakerId == respondent.surveyTakerId))) {
          this.battlecardSelectionMessage = "Only 30 individuals can be selected.";
        }
      } else {
        const displayedIds = new Set(displayed.map(respondent => respondent.surveyTakerId));
        this.battlecardSelectionMessage = "";
        this.selectedBattlecardRespondents = selected.filter(respondent => !displayedIds.has(respondent.surveyTakerId));
        this.emitBattlecardSelection();
        return;
      }
      this.selectedBattlecardRespondents = selected;
      this.emitBattlecardSelection();
    },
    sortIndividualRespondents(key) {
      if (this.individualRespondentSortKey === key) {
        this.individualRespondentSortDirection = this.individualRespondentSortDirection === "asc" ? "desc" : "asc";
      } else {
        this.individualRespondentSortKey = key;
        this.individualRespondentSortDirection = "asc";
      }
    },
    formatRespondentDate(value) {
      if (!value) return "";
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString();
    },
    runRoadmapSimulation() {
      if (!this.roadmapSimulationEnabled || this.disableChartCriteriaWidgets || this.roadmapAnalyzeDisabled) return;
      this.roadmapSimulationOnly = false;
      this.$emit("simulate-roadmap");
    },
    resetRoadmapV2Criteria() {
      this.roadmapSimulationFocus = "growth";
      this.valueProfileClientChartId = "";
      this.numberOfSuggestions = 5;
      this.roadmapAiTypeId = this.$parent.clientSettings && this.$parent.clientSettings.aiTypeId
        ? this.$parent.clientSettings.aiTypeId
        : 0;
      this.metric = "";
      this.roadmapSimulationOnly = false;
      this.hasChartRun = false;
      this.$parent.setDisplayView(false);
      this.$emit("select-value-profile", null);
      this.$emit("reset-roadmap-v2");
    },
    openSaveChartModal() {
      if (!this.stylesMode) this.$emit("prepare-roadmap-save");
      if (this.stylesMode && this.wizardMode && this.currentView === "battlecard") {
        this.$emit("prepare-battlecard-save");
      }
      this.$modal.show("save-chart-confirmation");
    },
    runChart(simulate = false) {
      if (this.stylesMode && this.currentView === "scout" && !this.validateScoutCriteria()) return;
      if (this.stylesMode) return ChartCriteria.methods.runChart.call(this);
      if (this.roadmapAnalyzeDisabled) return;
      this.resetSubChartCriteria();
      this.hasChartRun = true;
      this.roadmapSimulationOnly = simulate === true;
      this.setTotalMoatScoreAsDefaultForMoneyball();
      this.$parent.displayMainChart();
    },
    validateScoutCriteria() {
      if (this.scout_report_type !== "one-individual-over-time") {
        this.battlecardSelectionMessage = "";
        return true;
      }
      if (this.periods.length < 2) {
        this.battlecardSelectionMessage = "Select multiple Periods for One Individual Over Time.";
        return false;
      }
      if (this.selectedBattlecardRespondents.length !== 1) {
        this.battlecardSelectionMessage = "Select one individual for One Individual Over Time.";
        return false;
      }
      this.battlecardSelectionMessage = "";
      return true;
    },
    onScoutPeriodSelect(period) {
      if (period) period.checked = true;
    },
    onScoutPeriodRemove(period) {
      if (period) period.checked = false;
    },
    setSavedScoutPeriods(values = []) {
      this.periods = [];
      (Array.isArray(values) ? values : []).forEach(value => {
        const option = this.period_options.find(x => String(x.value) === String(value));
        if (option) {
          option.checked = true;
          this.periods.push(option);
        }
      });
    },
    setScoutDisplayType(view) {
      const displayType = view === "scout" ? "scout" : "sales-wizard";
      if (!this.stylesMode || this.displayType === displayType) return;
      this.displayType = displayType;
      this.saveResultValue(displayType, "Display Type", "display_type", true);
    },
    buildUrlParams(client_id) {
      if (this.stylesMode) {
        const params = ChartCriteria.methods.buildUrlParams.call(this, client_id);
        params.set("value_profile_client_chart_id", this.valueProfileClientChartId);
        params.delete("scout_report_type");
        params.delete("periods");
        if (this.currentView === "scout") {
          params.set("scout_report_type", this.scout_report_type);
          this.periods.forEach(period => params.append("periods", period.value));
        }
        const selectedRespondentIds = this.selectedBattlecardRespondents
          .map(respondent => respondent.surveyTakerId)
          .filter(value => value != null && value !== "");
        if (selectedRespondentIds.length > 0) {
          params.set("selected_respondents", JSON.stringify(selectedRespondentIds));
        } else {
          params.delete("selected_respondents");
        }
        return params;
      }
      const roadmapParams = new URLSearchParams();
      this.roadmapCriteriaResults = this.getRoadmapCriteriaResults();
      roadmapParams.append("client_id", client_id);
      roadmapParams.append("survey_id", SurveyService.getSurveyId());
      roadmapParams.append("user_id", UserService.getUserId());
      roadmapParams.append("display_type", "value-roadmap");
      roadmapParams.append("period", this.period);
      roadmapParams.append("value_profile_client_chart_id", this.valueProfileClientChartId);
      roadmapParams.append("number_of_suggestions", this.numberOfSuggestions);
      roadmapParams.append("roadmap_ai_type_id", this.roadmapAiTypeId);
      roadmapParams.append("metric", this.metric);
      roadmapParams.append("simulation_only", this.roadmapSimulationOnly);
      roadmapParams.append("roadmap_simulation_focus", this.roadmapSimulationFocus);
      if (typeof this.eChartCriteria.showTooltip === "boolean") roadmapParams.append("showTooltip", this.eChartCriteria.showTooltip);
      if (typeof this.eChartCriteria.displayNumberOfResponses === "boolean") roadmapParams.append("displayNumberOfResponses", this.eChartCriteria.displayNumberOfResponses);
      return roadmapParams;
    },
    loadOptions(response) {
      ChartCriteria.methods.loadOptions.call(this, response);
      this.setScoutDisplayType(this.currentView);
      if (this.$parent.chart.typeName == "competitive-profile") {
        if (!this.stylesMode) {
          const metricCriteria = this.findCriteria("Metric");
          this.metric_options = metricCriteria && Array.isArray(metricCriteria.options)
            ? metricCriteria.options
            : [{ name: SurveyService.getWTPLabel(), value: "-1" }, ...this.show_metric_groups_options];
        }
        this.loadRoadmapAiTypes();
      }
    },
    setDefaultValues() {
      ChartCriteria.methods.setDefaultValues.call(this);
      this.valueProfileClientChartId = "";
      this.scout_report_type = "multiple-individuals-separately";
      this.periods = [];
      this.individualRespondentRequestId++;
      this.individualRespondents = [];
      this.savedSelectedRespondentIds = [];
      this.selectedBattlecardRespondents = [];
      this.emitBattlecardSelection();
      if (this.stylesMode) {
        this.includeValueGaps = "Y";
        this.includeExpectations = "Y";
        this.includePerformance = "Y";
        this.includeCompetitor = "Y";
        this.includeWillingnessToPay = "Y";
        this.includeVerbatims = "Y";
        this.numberOfIdeas = 3;
        this.briefEmailRecipients = "";
        return;
      }
      this.roadmapSimulationFocus = "growth";
      this.numberOfSuggestions = 5;
      this.roadmapAiTypeId = this.$parent.clientSettings && this.$parent.clientSettings.aiTypeId
        ? this.$parent.clientSettings.aiTypeId
        : 0;
      this.metric = "";
      this.roadmapSimulationOnly = false;
    },
    resetStylesCriteria() {
      this.resetSubChartCriteria();
      this.individualRespondentRequestId++;
      this.individualRespondents = [];
      this.savedSelectedRespondentIds = [];
      this.valueProfileClientChartId = "";
      this.selectedBattlecardRespondents = [];
      this.includeValueGaps = "Y";
      this.includeExpectations = "Y";
      this.includePerformance = "Y";
      this.includeCompetitor = "Y";
      this.includeWillingnessToPay = "Y";
      this.includeVerbatims = "Y";
      this.numberOfIdeas = 3;
      this.briefEmailRecipients = "";
      this.$emit("select-value-profile", null);
      this.$emit("individual-respondents", this.individualRespondents);
      this.emitBattlecardCriteria();
      this.emitBattlecardSelection();
      this.resetChartCriteria();
    }
  },
  watch: {
    currentView: {
      immediate: true,
      handler(view) {
        this.setScoutDisplayType(view);
      }
    },
    battlecardCriteria: {
      immediate: true,
      deep: true,
      handler(criteria) {
        if (!this.wizardMode || criteria == null) return;
        this.includeValueGaps = criteria.includeValueGaps || "Y";
        this.includeExpectations = criteria.includeExpectations || "Y";
        this.includePerformance = criteria.includePerformance || "Y";
        this.includeCompetitor = criteria.includeCompetitor || "Y";
        this.includeWillingnessToPay = criteria.includeWillingnessToPay || "Y";
        this.includeVerbatims = criteria.includeVerbatims || "Y";
        this.numberOfIdeas = Number(criteria.numberOfRecommendations) || 0;
        this.roadmapAiTypeId = Number(criteria.salesWizardAiTypeId) || 0;
        this.briefEmailRecipients = criteria.briefEmailRecipients || "";
      }
    },
    individualRespondents: {
      deep: true,
      handler() {
        if (this.savedSelectedRespondentIds.length > 0) {
          this.$nextTick(() => {
            if (this.savedSelectedRespondentIds.length > 0 && this.individualRespondents.length > 0) {
              this.applySavedSelectedRespondentIds();
            }
          });
        }
      }
    },
    surveyCode() {
      this.individualRespondentRequestId++;
      this.individualRespondents = [];
      if (!this.$parent.autoGenerateChartRun) {
        this.valueProfileClientChartId = "";
      }
    },
    roadmapCriteriaSignature: {
      flush: "sync",
      handler() {
          if (!this.stylesMode) this.$emit("roadmap-criteria-changed");
      }
    },
    disableAiToolset() {
        if (this.stylesMode) return;
      if (this.disableAiToolset) this.roadmapAiTypeId = 0;
      $("#roadmapAiType").prop("disabled", this.disableChartCriteriaWidgets || this.disableAiToolset);
    },
    disableChartCriteriaWidgets() {
      this.$nextTick(() => {
        const disabled = this.disableChartCriteriaWidgets || this.disableAiToolset;
        $("#roadmapAiType, #battlecardAiType").prop("disabled", disabled);
      });
    }
  }
};
</script>
